import { TenantEntity } from '../TenantEntity'

export class AirExportFlightCustomer extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'AirExportFlightCustomer'
  }
  get flightNo() {
    return this._data.flightNo
  }
  set flightNo(flightNo) {
    this._data.flightNo = flightNo
  }
  get etd() {
    return this._data.etd
  }
  set etd(etd) {
    this._data.etd = etd
  }
  get customerId() {
    return this._data.customerId
  }
  set customerId(customerId) {
    this._data.customerId = customerId || 0
  }
  get business_Document() {
    return this._data.business_Document
  }
  set business_Document(business_Document) {
    this._data.business_Document = business_Document
  }
}
